<template>
  <router-view />
</template>
<script>
import 'bootstrap';
import '@mdi/font/css/materialdesignicons.css';

export default {};
</script>
